import { GraduationCap } from 'lucide-react'
import Link from 'next/link'
import { buttonIconVariants, buttonVariants, cn } from 'design-system'

export const SingleSignOnButton = () => (
  <Link
    href="/user/sso"
    className={cn(
      buttonVariants({ buttonType: 'white' }),
      'py-8 sm:py-8 md:py-8 lg:py-7'
    )}>
    {/* TODO update to /user/sso route*/}
    <GraduationCap
      aria-hidden
      className={buttonIconVariants({
        buttonSize: 'xs'
      })}
    />
    <span className="text-slate-800">
      Sign In with your Institutional Credentials (Single Sign On)
    </span>
  </Link>
)
